import { render } from "./PikuTradeComponent.vue?vue&type=template&id=6c1db66e&scoped=true&ts=true"
import script from "./PikuTradeComponent.vue?vue&type=script&lang=ts"
export * from "./PikuTradeComponent.vue?vue&type=script&lang=ts"

import "./PikuTradeComponent.vue?vue&type=style&index=0&id=6c1db66e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1db66e"]])

export default __exports__